export default {"src":"/_next/static/image/public/images/ic_circle_red_delete.f6ca3fe0d3890883ad85515bbf8a76c9.svg","height":40,"width":40};